import {
  BusinessProfileOption,
  CompanyCreationModes,
  CompanyCreationSteps,
  FranchiseOption,
} from '../../../../../views/companies';
import { BusinessType } from '../../../../../services/exports/Constants';

export default {
  title: 'Novo restaurante',
  sections: {
    new_company: {
      titles: {
        [CompanyCreationModes.demo]: 'Nova demonstração',
        [CompanyCreationModes.full]: 'Novo restaurante',
      },
      steps: {
        [CompanyCreationSteps.CompanyInfo]: 'Informação do restaurante',
        [CompanyCreationSteps.BusinessInfo]: 'Informação empresarial',
        [CompanyCreationSteps.AdditionalLocations]: 'Restaurantes adicionais',
      },
    },
    business_profile: {
      legal_info: 'Informação legal',
      owner_info: 'Informação do proprietário',
    },
    recently_created: 'Criados recentemente',
  },
  form: {
    franchise: {
      label: 'Criar Restaurante',
      tooltip:
        'Selecione se está a criar uma marca completamente nova ou a adicionar este restaurante a uma marca existente no nosso sistema.',
      options: {
        [FranchiseOption.CreateFranchise]: {
          title: 'Criar uma nova marca',
          tooltip: 'Estamos a começar do zero — sem marca ou restaurante existente',
        },
        [FranchiseOption.UseExistingFranchise]: {
          title: 'Adicionar este restaurante a uma marca existente',
          tooltip: 'Já pertence a uma marca existente no sistema',
        },
      },
    },
    restaurants: {
      label: 'Restaurante(s) associado(s)',
    },

    business_profile: {
      label: 'Quem é o proprietário?',
      tooltip:
        'Este restaurante pertence a um proprietário/empresa que já existe no nosso sistema (ex.: «Luís Pizza GmbH»)? <br/> Se sim, selecione esse perfil de proprietário/empresa existente. Caso contrário, crie um novo perfil de proprietário/empresa.',
      options: {
        [BusinessProfileOption.CreateBusinessProfile]: 'Criar novo perfil de proprietário/empresa',
        [BusinessProfileOption.UseExistingBusinessProfile]: 'Usar perfil de proprietário/empresa existente',
      },
    },
    business_type: {
      label: 'Tipo de empresa',
      placeholder: 'Selecionar tipo de empresa',
      options: {
        [BusinessType.Company]: 'Empresa',
        [BusinessType.Individual]: 'Empresário em nome individual',
      },
    },
    display_name: {
      label: 'Nome do restaurante',
      placeholder: 'Nome de apresentação',
    },
    legal_name: {
      label: 'Nome legal',
      placeholder: 'Nome legal',
    },
    owner_first_name: {
      label: 'Nome próprio do contacto',
      placeholder: 'James',
    },
    owner_last_name: {
      label: 'Apelido do contacto',
      placeholder: 'Bond',
    },
    owner_phone_number: {
      label: 'Telefone do contacto',
      placeholder: '1785080120',
    },
    owner_email: {
      label: 'Email do contacto',
      placeholder: 'Introduzir Email',
    },
    password: {
      label: 'Palavra-passe',
      placeholder: 'Introduzir Palavra-passe',
    },

    additional_companies: {
      label: 'Restaurantes adicionais sob esta marca',
      tooltip:
        'Existem restaurantes adicionais sob a mesma marca que {{company}}? <br/> Se sim, clique em «Adicionar Restaurante» para incluir mais localizações sob esta marca. Se for o mesmo proprietário mas uma marca diferente, não adicione aqui. Crie-o separadamente.',
    },
  },
  labels: {
    create_demo: 'Criar demonstração',
    create_company: 'Criar restaurante',
    business_type: 'Tipo de empresa',
    display_name: 'Nome de apresentação',
    legal_name: 'Nome legal',
    owner_name: 'Nome do proprietário',
    address: 'Morada',
  },
  fields: {
    name: 'Nome',
    created_at: 'Criado',
    actions: 'Ações',
  },

  buttons: {
    add_restaurant: '+ Adicionar restaurante',
    continue: 'Continuar',
    back: 'Voltar',
    create: 'Criar restaurante',
    delete: 'Eliminar',
  },
  popups: {
    delete_demo: {
      title: 'Tem a certeza que pretende eliminar?',
    },
  },
  toasts: {
    company_created: 'Restaurante criado com sucesso',
    failed_to_create_company: 'Falha ao criar restaurante',
    failed_to_delete_demo: 'Falha ao eliminar a demonstração',
    demo_got_deleted: 'Demonstração eliminada com sucesso',
    failed_to_load_recently_created_companies: 'Falha ao carregar restaurantes criados recentemente',
  },
};
